import cookies from "js-cookie";
import { setRealmCookie } from "src/cookies";
import { normalizeRealm } from "src/api/interfaces/realm";

const PAYEE_INTEGRATION_COOKIE_NAME = "payee_integration";
const REALM_PARAM_NAME = "realm";
const A_YEAR_IN_MILLISECONDS = 31536000000;

export const setPayeeIntegrationCookie = (): void => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get(PAYEE_INTEGRATION_COOKIE_NAME);
  const realm = params.get(REALM_PARAM_NAME);

  if (realm) {
    const normalizedRealm = normalizeRealm(realm);
    setRealmCookie(normalizedRealm);
  }

  if (token) {
    cookies.set(PAYEE_INTEGRATION_COOKIE_NAME, token, {
      path: "/",
      expires: new Date(Date.now() + A_YEAR_IN_MILLISECONDS),
    });
  }

  if (token || realm) {
    const url = new URL(window.location.href);
    url.searchParams.delete(PAYEE_INTEGRATION_COOKIE_NAME);
    url.searchParams.delete(REALM_PARAM_NAME);
    window.history.replaceState({}, document.title, url.toString());
  }
};

export const clearPayeeIntegrationCookie = (): void =>
  cookies.remove(PAYEE_INTEGRATION_COOKIE_NAME, { path: "/" });

export const getPayeeIntegrationCookie = (): string | undefined =>
  cookies.get(PAYEE_INTEGRATION_COOKIE_NAME);

export const isPayeeIntegrationCookieSet = (): boolean =>
  getPayeeIntegrationCookie() !== undefined;
